import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  INSTANT_WIN_PAYOUTS_PATH,
  INSTANT_WIN_PAYOUTS_DETAIL_PATH,
  INSTANT_WIN_PAYOUTS_DETAIL_ID_PATH,
} from "utils/constants/paths";

const InstantWinPayouts = Loadable(React.lazy(() => import("./View")));
const InstantWinPayoutDetail = Loadable(
  React.lazy(() => import("./View/Detail")),
);

export const InstantWinPayoutsRoute: IRouteItem = {
  path: INSTANT_WIN_PAYOUTS_PATH,
  iconName: "Wallet",
  element: React.createElement(InstantWinPayouts),
  name: "Payouts",
  accessKeys: ["Analyst"],
  children: [
    {
      name: "Detail",
      path: INSTANT_WIN_PAYOUTS_DETAIL_PATH,
      element: "",
      showInDrawer: false,
    },
    {
      path: INSTANT_WIN_PAYOUTS_DETAIL_ID_PATH,
      element: React.createElement(InstantWinPayoutDetail),
      showInDrawer: false,
    },
  ],
};
